module.exports = __webpack_public_path__ + "media/images/btn-arrow-dark-left-1812eff465d136c4b15bd67f57fc7009.svg";